/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseGuideSetting } from '../models/api-response-guide-setting';
import { ApiResponseListGuideSetting } from '../models/api-response-list-guide-setting';
import { list } from '../fn/guide-setting-api/list';
import { List$Params } from '../fn/guide-setting-api/list';
import { save } from '../fn/guide-setting-api/save';
import { Save$Params } from '../fn/guide-setting-api/save';

@Injectable({ providedIn: 'root' })
export class GuideSettingApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `save()` */
  static readonly SavePath = '/v1/api/admin-ui/guide-setting/save';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `save()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  save$Response(params: Save$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseGuideSetting>> {
    return save(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `save$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  save(params: Save$Params, context?: HttpContext): Observable<ApiResponseGuideSetting> {
    return this.save$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseGuideSetting>): ApiResponseGuideSetting => r.body)
    );
  }

  /** Path part for operation `list()` */
  static readonly ListPath = '/v1/api/admin-ui/guide-setting/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `list()` instead.
   *
   * This method doesn't expect any request body.
   */
  list$Response(params?: List$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListGuideSetting>> {
    return list(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `list$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  list(params?: List$Params, context?: HttpContext): Observable<ApiResponseListGuideSetting> {
    return this.list$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListGuideSetting>): ApiResponseListGuideSetting => r.body)
    );
  }

}
